import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, PropType, watch } from "vue";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import ChartForReports from "@/components/reports/ChartForReports.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { LeadInterface } from "@/types/LeadInterface";
  import LeadSourceEnum from "@/enums/LeadSourceEnum";
  import { ReportsTimePeriod } from "@/enums/ReportsTimePeriod";
  import { optionsForHorizontalBarchart } from "@/constants/optionsChart";
  import { chartBackgroundColor } from "@/constants/optionsChart";
  import ReportsByNumber from "@/components/reports/ReportsByNumber.vue";

  interface LeadsByEstate {
    title: string;
    source: string[];
    quantity: number[];
    total?: number;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminReportsByLeads',
  props: {
    estate: {
      type: Object as () => EstateInterface,
      required: true,
    },
    period: {
      type: String as PropType<ReportsTimePeriod>,
      required: true,
    },
    role: {
      type: String,
      required: false,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);

  const leadsByEstate = ref<LeadsByEstate>();
  const leadSource = [
    LeadSourceEnum.ENQUIRY,
    LeadSourceEnum.MANUALLY,
    LeadSourceEnum.IMPORT,
    LeadSourceEnum.WAITLIST,
    LeadSourceEnum.REA,
    LeadSourceEnum.INITIAL_HOLD,
  ];

  const estateSelected = computed(() => {
    return props.estate;
  });

  const periodSelected = computed(() => {
    return props.period;
  });

  watch(periodSelected, (newPeriod, oldPeriod) => {
    if (newPeriod !== oldPeriod) {
      getLeadsByEstate();
    }
  });

  const getSourceCountsByLeads = (
    leads: LeadInterface[],
    sourceByLead: string[]
  ) => {
    const sourceCounts: { [key: string]: number } = {};

    for (const source of sourceByLead) {
      sourceCounts[source] = 0;
    }

    for (const lead of leads) {
      const { source } = lead;

      if (sourceCounts[source] !== undefined) {
        sourceCounts[source]++;
      }
    }

    return sourceCounts;
  };

  const createLeadDataForChart = (
    estate: EstateInterface,
    sourceForData: string[],
    sourceCounts: { [key: string]: number }
  ) => {
    const leadData: {
      title: string;
      source: string[];
      quantity: number[];
    } = {
      title: estate.title,
      source: [],
      quantity: [],
    };

    for (const source of sourceForData) {
      leadData.source.push(source);
      leadData.quantity.push(sourceCounts[source]);
    }

    return leadData;
  };

  const filterLeadsByPeriod = (
    leads: LeadInterface[],
    period: ReportsTimePeriod
  ) => {
    const startDate = new Date();

    if (period === ReportsTimePeriod.LAST_WEEK) {
      startDate.setDate(startDate.getDate() - 7);
    } else if (period === ReportsTimePeriod.LAST_MONTH) {
      startDate.setMonth(startDate.getMonth() - 1);
      startDate.setDate(1);
    }

    return leads.filter((lead) => {
      const createdAt = new Date(lead.createdAt);

      return createdAt >= startDate;
    });
  };

  const getLeadsByEstate = async () => {
    loading.value = true;

    if (estateSelected.value) {
      store
        .dispatch("contact/getLeads", {
          estateId: estateSelected.value._id,
        })
        .then((res) => {
          const leadsWithinPeriod = filterLeadsByPeriod(
            res.data,
            periodSelected.value
          );
          const sourceCounts = getSourceCountsByLeads(
            leadsWithinPeriod,
            leadSource
          );
          const totalLeads = leadsWithinPeriod.length;

          leadsByEstate.value = {
            ...createLeadDataForChart(props?.estate, leadSource, sourceCounts),
            total: totalLeads,
          };
        })
        .catch((err) => {
          toast.error("Error getting Leads by estate");
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  onMounted(() => {
    getLeadsByEstate();
  });

const __returned__ = { props, store, toast, loading, leadsByEstate, leadSource, estateSelected, periodSelected, getSourceCountsByLeads, createLeadDataForChart, filterLeadsByPeriod, getLeadsByEstate, ref, onMounted, computed, PropType, watch, get useStore() { return useStore }, get useToast() { return useToast }, ChartForReports, get EstateInterface() { return EstateInterface }, get LeadInterface() { return LeadInterface }, get LeadSourceEnum() { return LeadSourceEnum }, get ReportsTimePeriod() { return ReportsTimePeriod }, get optionsForHorizontalBarchart() { return optionsForHorizontalBarchart }, get chartBackgroundColor() { return chartBackgroundColor }, ReportsByNumber }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})